/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Editor_AnonymousInputs */

const fr_legal_editor_anonymous = /** @type {(inputs: Legal_Editor_AnonymousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformément aux dispositions de l'article 6, III, 2° de la loi n° 2004-575 du 21 juin 2004 (LCEN), l'éditeur a choisi de rester anonyme. Les coordonnées personnelles ont été transmises en bonne et due forme à l'hébergeur.`)
};

const en_legal_editor_anonymous = /** @type {(inputs: Legal_Editor_AnonymousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In accordance with Article 6, III, 2 of French Law No. 2004-575 of June 21, 2004 (LCEN), the editor has chosen to remain anonymous. Personal contact details have been duly provided to the hosting provider.`)
};

/**
* | output |
* | --- |
* | "In accordance with Article 6, III, 2 of French Law No. 2004-575 of June 21, 2004 (LCEN), the editor has chosen to remain anonymous. Personal contact details ..." |
*
* @param {Legal_Editor_AnonymousInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_editor_anonymous = /** @type {((inputs?: Legal_Editor_AnonymousInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Editor_AnonymousInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_editor_anonymous(inputs)
	return en_legal_editor_anonymous(inputs)
});